import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import moment from 'moment-timezone'

import {closeTokenForm, generateTokens, updateNumberOfTokens, fetchCompaniesForBuilding, updateTokenCompany, showGenerateTokenError} from '../../actions/buildings'

class GenerateTokens extends Component {

  static defaultProps = {
  }

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  componentDidMount() {
  }

  closeDialog() {
    const { dispatch } = this.props
    dispatch(closeTokenForm())
  }

  generateTokens() {

    const { dispatch } = this.props

    if (!this.props.numberOfTokens || this.props.numberOfTokens <= 0) {
      dispatch(showGenerateTokenError("Please specify the number of tokens!"))
      return
    }

    if (!this.props.selectedTokenCompanyId) {
      dispatch(showGenerateTokenError("Please specify the company for witch the tokens should be generated"))
      return
    }

    dispatch(generateTokens(this.props.selectedBuildingForTokens, this.props.numberOfTokens, this.props.selectedTokenCompanyId))
  }

  updateNumberOfTokens(event) {
    const { dispatch } = this.props
    dispatch(updateNumberOfTokens(event.target.value))
  }

  updateTokenCompany(name, event, index, value) {
    const { dispatch } = this.props
    dispatch(updateTokenCompany(value))
  }

  render() {
      const actions = [
        <FlatButton
          label="Close"
          primary={true}
          onClick={this.closeDialog.bind(this)}
        />,
        <FlatButton
          label="Generate"
          primary={true}
          onClick={this.generateTokens.bind(this)}
        />,
      ];

      return (
        <Dialog
          actions={actions}
          title="Generate Tokens"
          modal={true}
          open={this.props.showTokenGenerationForm}>

          <TextField
                name="numberOfTokens"
                floatingLabelText="Number of Tokens"
                value={this.props.numberOfTokens}
                floatingLabelFixed={true}
                onChange={this.updateNumberOfTokens.bind(this)}
              />
          <br />
          <SelectField
            floatingLabelText="Company"
            value={this.props.selectedTokenCompanyId}
            onChange={this.updateTokenCompany.bind(this, 'companyId')}
          >
            {this.props.companies.map((company, index) =>
              <MenuItem value={company._id} primaryText={company.name} />
            )}
          </SelectField>
          <br />

          <div style={{ color: "red" }}>
            {this.props.generateError}
          </div>

        </Dialog>
      )
  }
}

const mapStateToProps = state => {
  return state.buildingsReducer
}

export default withRouter(
  connect(mapStateToProps)(GenerateTokens)
);



// WEBPACK FOOTER //
// ./src/components/buildings/GenerateTokens.js